import { FC } from "react";
import useSectionNavigationContext from "./use-section-navigation-context";
import { SectionNavigationContextComponentProps } from "./interfaces";

const SectionNavigationContextComponent: FC<SectionNavigationContextComponentProps> =
  ({ children }) => {
    const context = useSectionNavigationContext();

    return children(context);
  };

export default SectionNavigationContextComponent;
